import { IConnection } from './connection';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EndPointParams } from '../end-point-params.model';


/**
 * Clase para enviar las peticiones al back-end SBSiute.
 *
 * @export
 * @class SBSuiteHttpConnection
 * @implements {IConnection}
 */
export class SBSuiteHttpConnection implements IConnection{

    /**
     * Asistente para las peticiones al back-end.
     *
     * @private
     * @type {EndPointParams}
     * @memberof SBSuiteHttpConnection
     */
    private _ep: EndPointParams = null;

    /**
     * Opciones para las peticiones.
     *
     * @private
     * @type {*}
     * @memberof SBSuiteHttpConnection
     */
    private _options: any = {};

    /**
     * Tipo de conexión al back-end.
     *
     * @type {string}
     * @memberof SBSuiteHttpConnection
     */
    type: string = 'swap'


    /**
     * Guarda la instancia de HttpClient para realizar las peticiones.
     *
     * @private
     * @type {HttpClient}
     * @memberof SBSuiteHttpConnection
     */
    private _httpClient: HttpClient = null;



    /**
     * Crea la instancia de SBSuiteHttpConnection.
     *
     * Inicia el asistente para el back-end.
     *
     * @param {HttpClient} httpClient //Cliente de conexión http.
     * @memberof SBSuiteHttpConnection
     */
    constructor(httpClient: HttpClient, params:any = {}){
        this._httpClient = httpClient;
        this._ep = new EndPointParams(params);
    }


    /**
     * Devuelve el tipo de conexión al back-end.
     *
     * @returns {string}
     * @memberof SBSuiteHttpConnection
     */
    getType(): string{
        return this.type;
    }


    /**
     * @ignore
     *
     * @TODO: Eliminar.
     *
     * @returns {Observable<Array<string>>}
     * @memberof SBSuiteHttpConnection
     */
    getOperators(): Observable<Array<string>>{
        return null;

    }


    /**
     * Devuelve un observable de la consulta http
     * al endpoint /api/real/cambiarOperario/<operario>
     *
     * Datos disponibles en pruebas: 14...20
     * Ejemplo respuesta:
     *  {"status":"0",
     * "data":[
     *      {
     *          "cod_of":"180041",
     *          "cod_comanda":"4500295545",
     *          "observaciones":"",
     *          "nombre":"GIRBAU",
     *          "desc_producto_of":"TUBO VENTURI.",
     *          "desc_operacion":"MEC TORN 1",
     *          "id_reg_ofsprod_operacion":2493,
     *          "id_rt_operario":60
     *      },
     *      {
     *          "cod_of":"180078",
     *          "cod_comanda":"4500300366",
     *          "cod_comanda":"4500300366",
     *          "observaciones":"",
     *          "nombre":"GIRBAU",
     *          "desc_producto_of":"CASQUILLO RODAMIENTO.",
     *          "desc_operacion":"MEC TORN 2",
     *          "id_reg_ofsprod_operacion":2604,
     *          "id_rt_operario":null
     *      }
     *  ]
     * }
     *
     *
     *
     * @param {string} [operator='']
     * @returns {Observable<any>}
     * @memberof SBSuiteHttpConnection
     */
    cambiarOperario(operator: string = ''): Observable<any>{
        let url = `${this._ep.getUrl(EndPointParams.operation.cambiarOperario)}/${operator}`;
        return this._httpClient.get(url, this._options);
    }


    /**
     *  Devuelve un observable de la consulta http.
     * al endpoint /api/real/cambiarOf
     *
     * @param {string} [code=''] El código de la operación de producto
     * @param {string} [operator=''] El código del operador
     * @returns {Observable<any>}
     * @memberof SBSuiteHttpConnection
     */
    cambiarOf(code: string = '', operator: string = '', coord: string =''): Observable<any>{
        let url = `${this._ep.getUrl(EndPointParams.operation.cambiarOf)}?coord=${coord}`;
        let body = {
            cod_operario: operator,
            array_id_reg_ofsprod_operacion: [code]
        }

        return this._httpClient.post(url, body, this._options);
    }



    /**
     * Devuelve un observable de la consulta http
     * al endpoint /api/real/entrarOperario/<operario>.
     *
     * @param {string} [operator='']
     * @returns {Observable<any>}
     * @memberof SBSuiteHttpConnection
     */
    entrarOperario(operator: string = '', coord: string =''): Observable<any>{
        let url = `${this._ep.getUrl(EndPointParams.operation.entrarOperario)}/${operator}?coord=${coord}`;
        return this._httpClient.get(url, this._options);
    }

    /**
     * Devuelve un observable de la consulta http
     * al endpoint /api/real/salirOperario/<operario>.
     *
     * @param {string} [operator='']
     * @returns {Observable<any>}
     * @memberof SBSuiteHttpConnection
     */
    salirOperario(operator: string = '', coord: string =''): Observable<any>{
        let url = `${this._ep.getUrl(EndPointParams.operation.salirOperario)}/${operator}?coord=${coord}`;
        return this._httpClient.get(url, this._options);
    }



    /**
     * Devuelve un observable de la consulta http
     * al endpoint /api/real/listaOfsInternas.
     *
     * @returns {Observable<any>}
     * @memberof SBSuiteHttpConnection
     */
    listaOfsInternas(): Observable<any>{
        let url = this._ep.getUrl(EndPointParams.operation.listaOfsInternas);
        return this._httpClient.get(url, this._options);
    }


    /**
     * Devuelve un observable de la consulta http
     * al endpoint /api/manual/getOfsOperario.
     *
     * @param {string} [operator=''] El código del operador
     * @param {string} [date=''] La fecha en formato YYYYMMDD
     * @returns {Observable<any>}
     * @memberof SBSuiteHttpConnection
     */
    getOfsOperario(operator: string = '', date: string = ''): Observable<any>{
        let url = `${this._ep.getUrl(EndPointParams.operation.getOfsOperario)}/${operator}/${date}`;
        return this._httpClient.get(url, this._options);
    }


    /**
     * Devuelve un observable de la consulta http
     * al endpoint /api/getInformeTest.
     *
     * @param {string} [date1=''] La fecha en formato YYYYMMDD
     * @param {string} [date2=''] La fecha en formato YYYYMMDD
     * @returns {Observable<any>}
     * @memberof SBSuiteHttpConnection
     */
    getInformeTest(date1: string = '', date2: string = ''): Observable<any>{
      let url = `${this._ep.getUrl(EndPointParams.operation.getInformeTest)}?P0=${date1}&P1=${date2}`;
      //console.log("http-connection-sbuite getInformeTest.url: " + url);
      return this._httpClient.get(url, this._options);
  }

    /**
     * Devuelve un observable de la consulta http
     * al endpoint /api/manual/getOfsDropdown.
     *
     * @param {string} [of='']
     * @returns {Observable<any>}
     * @memberof SBSuiteHttpConnection
     */
    getProductosOfDropdown(of: string = ''): Observable<any>{
        let url = `${this._ep.getUrl(EndPointParams.operation.getProductosOfDropdown)}/${of}`;
        return this._httpClient.get(url, this._options);
    }

    /**
     * Devuelve un observable de la consulta http
     * al endpoint /api/manual/getOpsProdOfDropdown.
     *
     * @param {string} product El código de producto
     * @returns {Observable<any>}
     * @memberof SBSuiteHttpConnection
     */
    getOpsProdOfDropdown(product: string): Observable<any>{
        let url = `${this._ep.getUrl(EndPointParams.operation.getOpsProdOfDropdown)}/${product}`;
        return this._httpClient.get(url, this._options);
    }


    /**
     * Devuelve un observable de la consulta http
     * al endpoint /api/manual/ModHorasOpProdOf.
     *
     * @param {string} [register=''] El id del registro a modificar
     * @param {*} clockIn Los parámetros necesarios del body
     * @returns {Observable<any>}
     * @memberof SBSuiteHttpConnection
     */
    modHorasOpProdOf(register: string = '', clockIn: any): Observable<any>{
        let url = `${this._ep.getUrl(EndPointParams.operation.modHorasOpProdOf)}/${register}`;
        return this._httpClient.post(url, clockIn, this._options);
    }

    /**
     * Devuelve un observable de la consulta http
     * al endpoint /api/manual/AnadirHorasOpProdOf.
     *
     * @param {*} clockIn Los parámetros necesarios del body
     * @returns {Observable<any>}
     * @memberof SBSuiteHttpConnection
     */
    anadirHorasOpProdOf(clockIn: any): Observable<any>{
        let url = this._ep.getUrl(EndPointParams.operation.anadirHorasOpProdOf);
        return this._httpClient.post(url, clockIn, this._options);
    }

    /**
     * Devuelve un observable de la consulta http
     * al endpoint /api/manual/delHorasOpProdOf.
     *
     * @param {string} [register=''] El id del registro a eliminar
     * @returns {Observable<any>}
     * @memberof SBSuiteHttpConnection
     */
    delHorasOpProdOf(register: string=''): Observable<any>{
        let url = `${this._ep.getUrl(EndPointParams.operation.delHorasOpProdOf)}/${register}`;
        return this._httpClient.post(url,{}, this._options);
    }

    /**
     * Devuelve un observable de la consulta http
     * al endpoint /api/manual/delHorasOpProdOf.
     *
     * @returns
     * @memberof SBSuiteHttpConnection
     */
    getParams(){
        let url = this._ep.getUrl(EndPointParams.operation.getParams);
        return this._httpClient.get(url, this._options);
    }

    /**
     * Devuelve un observable de la consulta http
     * al endpoint /api/getLogo.
     *
     * @returns
     * @memberof SBSuiteHttpConnection
     */
    getLogo(){
        let url = this._ep.getUrl(EndPointParams.operation.getLogo);
        return this._httpClient.get(url);
    }

	/**
     * Devuelve un observable de la consulta http
     * al endpoint /api/login.
     *
     * @param {{username:string, password:string}} [credentials={username:'',password:''}]
     * @returns {Observable<any>}
     * @memberof SBSuiteHttpConnection
     */
    login(credentials: {username:string, password:string} = {username:'',password:''}): Observable<any>{
        let url = this._ep.getUrl(EndPointParams.operation.login);
        return this._httpClient.post(url,credentials);
    }

    /**
     * Devuelve un observable de la consulta http
     * al endpoint /login.
     *
     * @param {string} [operator='']
     * @returns
     * @memberof SBSuiteHttpConnection
     */
    operario(operator: string = ''){
        let url = `${this._ep.getUrl(EndPointParams.operation.operario)}/${operator}`;
        return this._httpClient.get(url,this._options);
    }

    /**
     * Establece el token de autenticación para las peticiones http.
     *
     * @param {string} [token=''] Token obtenido.
     * @memberof SBSuiteHttpConnection
     */
    setToken(token: string = ''){
       let headers = new HttpHeaders().set('authorization', token);
       this._options = {headers: headers};
       //this._options = {};
    }

}



// WEBPACK FOOTER //
// ./src/modules/sbsuite/models/connection/http-connection-sbsuite.ts